import React, { FC } from 'react';
import { Footer as FooterComponent } from '@agria/theme/src/components/footer/Footer';
import { useSiteMetadata } from '@agria/theme/src/hooks/useSiteMetadata';

export const Footer: FC = () => {
  const {
    footerShowCookieButton,
    footerNavigationColumns,
    footerSecondaryNavigation,
    footerSocialLinks,
    footerTerms,
  } = useSiteMetadata();

  return (
    <FooterComponent
      navigationColumns={footerNavigationColumns}
      smallText={footerTerms}
      socialLinks={footerSocialLinks}
      secondaryNavigation={footerSecondaryNavigation}
      showCookieButton={footerShowCookieButton}
    />
  );
};
